import { createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

export const SET_FILTER = '/vehicles/filters/setFilter';
export const CLEAN_FILTER = '/vehicles/filters/cleanFilter';

export type PersistFiltersState = Record<string, Record<string, any>>;

const initialState: PersistFiltersState = {};

export type PersistFilterPayload = {
  // Уникальный путь до фильтра (например, url страницы)
  path: string;
  // Значения, которые необходимо записать
  values: any;
};

const persistFiltersSlice = createSlice({
  name: '/vehicles/filters',
  initialState,
  reducers: {
    setFilter: (state, { payload }: { payload: PersistFilterPayload }) => {
      state[payload.path] = { ...payload.values };
    },
    cleanFilter: (state, { payload }: { payload: string }) => {
      state[payload] = {};
    },
  }
});

export const persistFiltersActions = persistFiltersSlice.actions;

/**
 * Проставление фильтра
 */
export const setFilter = (payload: PersistFilterPayload) => (
  dispatch: Dispatch
) => {
  dispatch(persistFiltersActions.setFilter(payload));
};

export default persistFiltersSlice.reducer;
